import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from '../components/home/Navbar.jsx';
import Footer from '../components/common/Footer.jsx';
import logo from '../assets/logo.jpeg';

const MainLayout = () => (
  <div className="min-h-screen flex flex-col relative overflow-hidden">
    {/* Background Watermark Logo */}
    <div className="pointer-events-none select-none fixed inset-0 z-30 flex items-center justify-center overflow-hidden opacity-[0.018]">
      <img 
        src={logo} 
        alt="Watermark Logo" 
        className="w-[60vw] max-w-[600px] aspect-square object-contain filter invert mix-blend-screen" 
      />
    </div>
    
    <div className="flex-1 flex flex-col z-10 relative">
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  </div>
);

export default MainLayout;
